export default __webpack_public_path__ + "static/media/Login.a62223e5.svg";